import { CommonService } from "../../services/common/commonService";
import { Outlet } from "react-router-dom";

const LandingLayout = () => {
  return (
    <>
      <CommonService>
        <Outlet />
      </CommonService>
    </>
  );
};

export default LandingLayout;
